import { render, staticRenderFns } from "./phoneRegister.vue?vue&type=template&id=c53a6418"
import script from "./phoneRegister.vue?vue&type=script&lang=js"
export * from "./phoneRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports